import { render, staticRenderFns } from "./okx.vue?vue&type=template&id=cced6bde&"
import script from "./okx.vue?vue&type=script&lang=ts&"
export * from "./okx.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports